import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private oauthService: OAuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }

    const tenantName = localStorage.getItem('__tenant');
    const loginUrl = tenantName
      ? `/account/login?__tenant=${encodeURIComponent(tenantName)}`
      : '/account/login';
    return this.router.parseUrl(loginUrl);
  }
}
